module.exports = __webpack_public_path__ + "img/dzxx01.0ea2fe0.png";